/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIAgentsObservabilityRequestBase {
    getFixupPrototypeFunction() { return AIAgentsObservabilityRequestBase.fixupPrototype; }

    static newInstance(model: Partial<AIAgentsObservabilityRequestBase>): AIAgentsObservabilityRequestBase {
        let obj = Object.assign(new AIAgentsObservabilityRequestBase(), model);
        AIAgentsObservabilityRequestBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIAgentsObservabilityRequestBase>): AIAgentsObservabilityRequestBase {
        if (!model) return null;
        return AIAgentsObservabilityRequestBase.newInstance(<AIAgentsObservabilityRequestBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIAgentsObservabilityRequestBase) {
        if (!obj) return;

        models.AIAgentsObservabilityRequestBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIAgentsObservabilityRequestBase): boolean {
        Object.setPrototypeOf(obj, AIAgentsObservabilityRequestBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Query operator filter; pass a ServiceAccountQueryOperator to scope agents by service account
     */
    filters: models.QueryOperator;

    /**
     * Start of the time range
     */
    start_date: Date;

    /**
     * End of the time range
     */
    end_date: Date;

}
